import { defineComponent as _defineComponent } from 'vue'
import { useContext, computed } from '@nuxtjs/composition-api';
import { numberWithCommas } from '~/utils/formatStrings';
import { Resource } from '~/types/resource';

interface Props {
  post: Resource;
  type?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthorToolbar',
  props: {
    post: null,
    type: { default: 'resource' }
  },
  setup(__props: any) {

const props = __props as { post: Resource, type: string };



const { $config } = useContext();

const adminUrl = computed(() => {
  if (props.post?.root && props.post?.root?.slug) {
    return (
      $config.wpURL +
      '/wp-admin/term.php?taxonomy=' +
      props.post.slug +
      '&tag_ID=' +
      props.post.old_id
    );
  }
  return $config.wpURL + '/wp-admin/post.php?post=' + props.post.old_id + '&action=edit';
});

return { __sfc: true,props, $config, adminUrl, numberWithCommas }
}

})